import {NgClass} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {ProcessPingInfo} from '@compiere-ws/models/process-ping-info';
import {CustomDesignItemType} from '@iupics-components/models/custom-design';
import ButtonUiComponent from '@iupics-components/standard/fields/button-ui/button-ui.component';
import ModalUiComponent from '@iupics-components/standard/layouts/modal-ui/modal-ui.component';
import {AbstractDataContainer} from '@iupics-manager/models/abstract-datacontainer';
import {DynamicContainerDirective} from '@iupics-util/directives/dynamic-container.directive';
import {TranslateModule} from '@ngx-translate/core';
import {ProgressBarModule} from 'primeng/progressbar';
import {ScrollPanelModule} from 'primeng/scrollpanel';
import SpecificWindowUiComponent from '../specific-window-ui/specific-window-ui.component';

@Component({
    selector: 'iu-create-from-open-invoice',
    templateUrl: './create-from-open-invoice.component.html',
    styleUrls: ['./create-from-open-invoice.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        ProgressBarModule,
        ScrollPanelModule,
        DynamicContainerDirective,
        ButtonUiComponent,
        ModalUiComponent,
        // UniversalFilterUiComponent,
        // GridTabInfinityScrollUiComponent,
        TranslateModule,
    ],
})
export default class CreateFromOpenInvoiceComponent extends SpecificWindowUiComponent implements OnInit {
    private nbLinesField: AbstractDataContainer;
    private totalField: AbstractDataContainer;
    private soldeField: AbstractDataContainer;
    isModal: boolean = false;

    ngOnInit() {
        this.customDesignArray.push(
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'AD_Client_ID',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'C_BPartner_ID',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'C_Payment_ID',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'C_DocType_ID',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'Total',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'COUNT',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.FIELD,
                columnName: 'SOLDE',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            },
            {
                vcr: 'vcr',
                type: CustomDesignItemType.GRID,
                tableName: 'Create From Open Invoice Table',
                cssClass: 'p-col-12',
            },
            {
                vcr: 'vcrButtons',
                type: CustomDesignItemType.FIELD,
                columnName: 'Processing',
                cssClass: 'p-col-6 p-md-4 p-lg-2',
            }
        );
        super.ngOnInit();
        this.showSpecificWindow();
    }

    notifyFromDatacontainerInit(dataContainer: AbstractDataContainer) {
        if (dataContainer.data.columnName === 'COUNT') {
            this.nbLinesField = dataContainer;
        }
        if (dataContainer.data.columnName === 'Total') {
            this.totalField = dataContainer;
        }
        if (dataContainer.data.columnName === 'SOLDE') {
            this.soldeField = dataContainer;
        }
    }

    notifyFromRowSelected(rowSelected: any) {
        const gridFound = this.getGrid('Create From Open Invoice Table');
        if (!gridFound?.GridTabInfinityScrollUiComponent?.grid?.api) {
            return;
        }
        this.refreshFields();
    }

    refreshFields() {
        let total = 0;
        let nbLines = 0;
        let solde = 0;
        const lineSelecteds = this.getGridSelection('Create From Open Invoice Table');
        if (lineSelecteds && lineSelecteds.length > 0) {
            solde = this.getFormStoreData('PayAmt');
            for (const rowData of lineSelecteds) {
                if (rowData['Open'] !== undefined && rowData['Open'] !== null) {
                    total += rowData['Open'];
                    solde -= rowData['Open'];
                }
                nbLines++;
            }
        }
        this.totalField.updateStore(Number(total.toFixed(2)));
        this.nbLinesField.updateStore(nbLines);
        this.soldeField.updateStore(Number(solde.toFixed(2)));
    }

    onEndProcess(ping: ProcessPingInfo) {
        this.clearGridSelection('Create From Open Invoice Table');
        super.onEndProcess(ping);
        this.totalField.updateStore(0);
        this.nbLinesField.updateStore(0);
        this.soldeField.updateStore(0);
    }
}
